<template>
    <div class="ur-tab__navi">
<!--        <div class="ur-tab__navi__item ur-tab__navi__item&#45;&#45;left"  :class="leftClazz"  @click="clickLeft"  v-if="tabBox.navi">-->
<!--            <ur-icon iconType="picto">expand_menu</ur-icon>-->
<!--        </div>-->
<!--        <div class="ur-tab__navi__item ur-tab__navi__item&#45;&#45;right" :class="rightClazz" @click="clickRight" v-if="tabBox.navi">-->
<!--            <ur-icon iconType="picto">expand_menu</ur-icon>-->
<!--        </div>-->
        <div class="ur-tab__navi__item ur-tab__navi__item--add"   @click="clickAdd" v-if="tabBox.addBtn">
            <ur-icon iconType="picto">add</ur-icon>
        </div>
    </div>
</template>

<script>
export default {
    name : "urTabNavi",
    inject:['tabBox'],
    computed: {
        labs() {return this.tabBox.idxs || []},
        curr() {return this.tabBox.currIdx},
        isFirst() {return this.labs[0] === this.curr},
        isLast()  {return this.labs[this.labs.length-1] === this.curr},
        leftClazz() {
            return {'ur-tab__navi__item--disable':this.isFirst}
        },
        rightClazz() {
            return {'ur-tab__navi__item--disable':this.isLast}
        },
    },
    methods : {
        clickLeft() {
            if(this.isFirst) return;
            var i = this.labs.findIndex(l => l===this.curr);
            // TODO need check out of bound array?
            this.tabBox.setIdx(this.labs[i-1]);
        },
        clickRight() {
            if(this.isLast) return;
            var i = this.labs.findIndex(l => l===this.curr);
            // TODO need check out of bound array?
            this.tabBox.setIdx(this.labs[i+1]);
        },
        clickAdd(e) {
            this.tabBox.onAddClick(e);
        }
    }
}

</script>